<style>
    #consultant-programs-page table thead th:last-child {
        border-radius: 0;
    }
</style>

<template>
    <data-table
        table-id="connected-programs-table"
        :items="connectedPrograms"
        :fields="connectedFields"
        :empty-text="connectedEmptyText"
        :loading="loadingConnectedPrograms"
    >
        <template #name="{ item }">
            <a :href="$basePath+'/my-programs/'+item.id">{{item.name}}&nbsp;&nbsp;<i class="fas fa-angle-right"></i></a>
        </template>
        <template #mostRecentAssessmentDate="{ item, formattedCellData }">
            <div v-if="item.mostRecentAssessment" class="row icon-name-date">
                <div class="col-3 connected-icon">
                    <div v-bind:class="item.mostRecentAssessment.module.icon + ' icon-rounded-corners pull-left module-icons-sm bg-'+ item.mostRecentAssessment.module.color"></div>
                </div>
                <div class="col connected-name-date">
                    <div class="connected-name">{{ item.mostRecentAssessment.module.name }}</div>
                    <div class="connected-date">{{ formatDate(item.mostRecentAssessment.finalized_at) }}</div>
                </div>
            </div>
        </template>
        <template #mostRecentCompletedTraining="{item}">
            <div v-if="item.mostRecentCompletedTraining" class="row icon-name-date">
                <div class="col-3 connected-icon">
                    <div  v-bind:class="' icon-rounded-corners pull-left module-icons-sm bg-'+ item.mostRecentCompletedTraining.module.color" :style="{'background':`url(${$basePath}/images/action_plans/${item.mostRecentCompletedTraining.section.btn_image})`,'background-size':'contain'}"></div>
                </div>
                <div class="col connected-name-date">
                    <div class="connected-name">{{item.mostRecentCompletedTraining.section.name}}
                        <br />
                        <small>{{item.mostRecentCompletedTraining.module.name}}</small>
                    </div>
                    <div class="connected-date">{{ formatDate(item.mostRecentCompletedTraining.finalized_at) }}</div>
                </div>
            </div>
        </template>
        <template #mostRecentActionPlanDate="{item}">
            <div v-if="item.mostRecentActionPlan" class="row icon-name-date">
                <div class="col-3 connected-icon">
                    <div v-bind:class="item.mostRecentActionPlan.icon + ' icon-rounded-corners pull-left module-icons-sm bg-'+ item.mostRecentActionPlan.color"></div>
                </div>
                <div class="col connected-name-date">
                    <div class="connected-name">{{item.mostRecentActionPlan.name}}</div>
                    <div class="connected-date">{{ formatDate(item.mostRecentActionPlan.date) }}</div>
                </div>
            </div>
        </template>
        <template #disconnect="{ item }">
            <a class="btn-orange-blue btn-sm"
                @click="disconnect(item, 'connected')"
            >
                Disconnect
            </a>
            <a class="btn-x" 
                @click="disconnect(item, 'connected')"
            >
                <i class="fa fa-times" aria-hidden="true"></i>
            </a>
        </template>
    </data-table>
</template>

<script>
    // import _ from 'lodash';
    import moment from 'moment'
    import DataTable from '../../DataTable.vue';

    export default {
        components: {
            DataTable,
        },
        props: {
        },
        data() {
            return {
                connectedPrograms: [],
                connectedFields: [
                    {
                        key: 'name',
                        label: 'User Information',
                        sortable: true,
                        thStyle: {width: '20%'},
                        compareFn: 'compareByKey',

                    },
                    {
                        key: 'connected',
                        label: 'Connected',
                        sortable: true,
                        thStyle:{width:'95px'},
                        compareFn: 'compareDateByKey',
                        formatFn: 'formatDate',
                        formatOptions: {
                            'format': 'MM/DD/YY'
                        }
                    },
                    {
                        key: 'mostRecentAssessmentDate',
                        label: 'Most Recent Self-Assessment',
                        sortable: true,
                        class: 'td-connected-sa',
                        compareFn: 'compareDateByKey',
                        compareKey: 'mostRecentAssessment.finalized_at',
                        displayKey: 'mostRecentAssessment.finalized_at',
                        formatFn: 'formatDate',
                        formatOptions: {
                            'format': 'MM/DD/YYYY'
                        }
                    },
                    {
                        key: 'mostRecentCompletedTraining',
                        label: 'Most Recent Training Completed',
                        sortable: true,
                        class: 'td-connected-sa',
                        compareFn: 'compareDateByKey',
                        compareKey: 'mostRecentCompletedTraining.finalized_at',
                        displayKey: 'mostRecentCompletedTraining.finalized_at',
                        formatFn: 'formatDate',
                        formatOptions: {
                            'format': 'MM/DD/YYYY'
                        }
                    },
                    {
                        key: 'mostRecentActionPlanDate',
                        label: 'Most Recent Action Planning',
                        sortable: true,
                        class: 'td-connected-ap',
                        compareFn: 'compareDateByKey',
                        compareKey: 'mostRecentActionPlan.date',
                        displayKey: 'mostRecentActionPlan.date',
                        formatFn: 'formatDate',
                        formatOptions: {
                            'format': 'MM/DD/YYYY'
                        }
                    },
                    {
                        key: 'disconnect',
                        label: 'Disconnect',
                        sortable: false,
                        thStyle:{width:'85px'}
                    }
                ],
                loadingConnectedPrograms: false,
            }
        },
        computed: {
            connectedEmptyText: function() {
                return 'You are not yet connected to any programs';
            },
        },
        methods: {
            getConnectedPrograms(){
                this.loadingConnectedPrograms = true;
                axios('/api/consultants/connected-programs')
                    .then((response) => {
                        this.connectedPrograms = response.data.data;
                        var children_served = 0;
                        for( var i = 0; i< this.connectedPrograms.length ; i++ ) {
                          children_served = children_served + this.connectedPrograms[i].children;
                        }
                        this.loadingConnectedPrograms = false;
                    })
                    .catch((error) => {
                        this.loadingConnectedPrograms = false;
                    })
            },
            disconnect(item){
                if(confirm('Are you sure you want to disconnect from this program?')) {
                    axios('/api/consultants/disconnect-program/'+item.id)
                    .then(function (response) {
                        this.connectedPrograms.splice(this.connectedPrograms.indexOf(item), 1);
                    }.bind(this))
                    .catch(function (error) {
                        console.error(error);
                    })
                }
            },
            formatDate(dateStr, formatStr = "MM/DD/YYYY") {
                return moment(dateStr).utc().format(formatStr)
            },
        },
        mounted: function(){
            this.getConnectedPrograms()
        }        
    }
</script>